import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Switch } from "./ui/switch";
import { toast } from "sonner";

const ORDER = ["deals", "messages", "reminders", "news"];

export function EmailPreferences() {
  const [prefs, setPrefs] = useState(null);
  const [labels, setLabels] = useState({});

  useEffect(() => {
    api.get("/auth/email-prefs").then((r) => { setPrefs(r.data.prefs); setLabels(r.data.labels || {}); }).catch(() => setPrefs({}));
  }, []);

  const toggle = async (key, value) => {
    const prev = prefs;
    setPrefs({ ...prefs, [key]: value });
    try {
      const { data } = await api.patch("/auth/email-prefs", { [key]: value });
      setPrefs(data.prefs);
    } catch (e) {
      setPrefs(prev);
      toast.error(formatApiError(e.response?.data?.detail) || "Could not save");
    }
  };

  if (!prefs) return <div className="text-sm text-zinc-500">Loading…</div>;
  return (
    <div className="space-y-3" data-testid="email-preferences">
      <div id="emails" />
      {ORDER.map((k) => {
        const [title, desc] = (labels[k] || k).split(" — ");
        return (
          <label key={k} className="flex items-center justify-between gap-4 p-3 rounded-xl bg-white/[0.02] hairline cursor-pointer" data-testid={`email-pref-${k}`}>
            <div className="min-w-0">
              <div className="text-sm text-white font-semibold">{title}</div>
              {desc && <div className="text-xs text-zinc-500 mt-0.5">{desc}</div>}
            </div>
            <Switch checked={prefs[k] !== false} onCheckedChange={(v) => toggle(k, v)} data-testid={`email-pref-${k}-switch`} />
          </label>
        );
      })}
      <p className="text-[11px] text-zinc-500">Essential account emails (verification codes, security alerts) are always sent. Every email also has a one-click unsubscribe link.</p>
    </div>
  );
}
